import { gql } from '@apollo/client';
import config from 'config';

const storesIndex = config.algolia.algolia_prefix + 'stores';

export const GET_STORES = gql`
query AlgoliaGetStores ($query : String!, $filters: String!, $hit : Number!, $page : Number!) {
  algoliaGetStores @algolia(__typename: "ALGOLIA_GET_STORES", index: ${storesIndex}, filters: $filters, hitsPerPage: $hit, query: $query, page: $page) {
      hits
      nbHits
      facets
      page
      nbPages
  }
}
`;

export const GET_STORE_DETAIL_BY_ID = gql`
    query GetStoreById($input: GetStoreByIdInput!) {
        getStoreById(input: $input) {
            id
            taffiId
            name
            description
            url
            shopifyDomain
            defaultWidgetStateOpen
            defaultPagePath
            enableCustomWidgetScript
            customWidgetScript
            isTestStore
            enableShopifyItemSearch
            tagsToIdentifyMan
            tagsToIdentifyWoman
            productTargetGender
            filterConfigResponse {
                disallowedStores
            }
        }
    }
`;

export const GET_STORE_BY_DOMAIN = gql`
    query GetStoreByDomain($input: GetStoreByDomainInput!) {
        getStoreByDomain(input: $input) {
            approved
            id
            showTaffiWidget
            showFloatingButton
            enableVtonFeature
            showAskAmiraCardPDP
            enableProductSpecificQuestion
            plpURLParams
            showDressItRightCardPDP
            plpWidgetReplaceItemCard
            displayTitlePDP
            displayTitlePLP
            name
            platform
            languageCode
            taffiId
            url
            shopifyDomain
            defaultWidgetStateOpen
            defaultPagePath
            enableCustomWidgetScript
            customWidgetScript
            isTestStore
            enableShopifyItemSearch
            tagsToIdentifyMan
            tagsToIdentifyWoman
            productTargetGender
            enableStyleSession
            supportedLanguages
            displayWidgetURLs
            hideWidgetURLs
            hideTaffiWidgetButtonImage
            taffiWidgetButtonImageURL
            taffiWidgetButtonText
            suggestedQuestionIds
            popupQuestionsDelay
            filterConfigResponse {
                disallowedStores
            }
            affiliateLink
            enableStyleWidget
            styleWidgetPosition
            productPagePattern
            productPageElementSelectorPattern
            styleWidgetTargetElement
            alternativeStyleWidgetTargetElement {
                targetElement
                insertPosition
            }
            styleWidgetAutoPlayDelay
            widgetCustomCss
            taffiWidgetCollapsible
            taffiWidgetCollapsibleDelay
            enableListingStyles
            enableSingleProductStyling
            enableEngagingSlider
            numOfStoreItemsPerTaffiStyle
            scrollCountForAmiraCard
            listingStyleContainers {
                path
                container
                productCardSelector
                productRowSelector
            }
            daysToGetStyles
            devAttributes
            stringTranslator
            devIPs
            styleLayoutVersion
            enableSearchWidget
            searchQuestionIds
            searchWidgetConfig {
                targetElement
                insertPosition
                resetElement
                isPredictiveSearch
                isDynamicInjection
                dynamicInjectionTargetElement
            }
            searchWidgetResultConfig {
                targetElement
                insertPosition
                wrapperClass
                contentContainerClass
            }
            allowedStyleStatus
            allowedItemCategoriesFromOtherStores
            enableTryOnFeature
        }
    }
`;

export const GET_STORE_PRODUCTS = gql`
    query GetStoreProducts($input: GetStoreProductsInput!) {
        getStoreProducts(input: $input) {
            products {
                id
                title
                description
                onlineStoreUrl
                images
                options {
                    name
                    values
                }
                tags
                vendor
                availableForSale
                variants {
                    price
                    currency
                }
            }
            pageInfo {
                endCursor
                hasNextPage
                hasPreviousPage
            }
        }
    }
`;
